import { createSlice } from '@reduxjs/toolkit';
import { clientQuestionnairesInitialState } from './initial_states';

export const clientQuestionnairesSlice = createSlice({
  name: 'clientQuestionnaires',
  initialState: clientQuestionnairesInitialState,
  reducers: {
    setAnswerQuestionnaire(state, action) {
      const { questions, type } = action.payload;
      if (state[type]) {
        state[type].questions = questions;
      }
    },
    toggleChoice(state, action) {
      const { value, questionNumber, type } = action.payload;
      const questionnaire = state[type];
      const question = questionnaire.questions.find((q) => q.question_num === questionNumber);

      let updatedQuestions;
      const choices = question.choices.map((choice: any) => ({
        ...choice,
        selected: choice.title === value.toString(),
      }));

      updatedQuestions = questionnaire.questions.map((q) =>
        q.question_num === questionNumber ? { ...q, choices } : q
      );

      state[type] = {
        ...questionnaire,
        questions: updatedQuestions,
      };
    },
    updateSubquestion(state, action) {
      const { value, questionNumber, type, inputType } = action.payload;
      const questionnaire = state[type];
      const mainQuestion = questionnaire.questions.find((q: any) => q.question_num === questionNumber);

      if (mainQuestion) {
        const subQuestion = mainQuestion.subquestion;

        if (subQuestion) {
          switch (inputType) {
            case 'radio':
              subQuestion.choices.forEach((choice: any) => {
                choice.selected = choice.title === value;
              });
              break;
            case 'input':
              subQuestion.value = value;
              break;
            case 'textarea':
              subQuestion.value = value;
              break;
            case 'multi-checkbox':
              subQuestion.choices.forEach((choice: any) => {
                if (Array.isArray(value)) {
                  choice.selected = value.includes(choice.title);
                } else if (choice.title === value) {
                  choice.selected = !choice.selected;
                }
              });
              break;
            default:
          }
        }
      }
    },
    updateSubquestions(state, action) {
      const { value, questionNumber, type, inputType, subquestionsIndex } = action.payload;
      const questionnaire = state[type];
      const mainQuestion = questionnaire.questions.find((q: any) => q.question_num === questionNumber);

      if (mainQuestion) {
        const subQuestions = mainQuestion.subquestions;

        if (subQuestions) {

          let updatedSubQuestion: any;
          if (inputType === 'radio' || inputType === 'horizontal-radio') {
            const updatedChoices = subQuestions[subquestionsIndex].choices.map((choice: any) => ({
              ...choice,
              selected: choice.title === value,
            }));

            updatedSubQuestion = {
              ...subQuestions[subquestionsIndex],
              choices: updatedChoices,
            };
          } else if (inputType === 'input' || inputType === 'textarea') {
            updatedSubQuestion = {
              ...subQuestions[subquestionsIndex],
              value: value,
            };
          }

          const updatedSubQuestions = subQuestions.map((sq: any, index: number) =>
            index === subquestionsIndex ? updatedSubQuestion : sq
          );
          const updatedQuestions = questionnaire.questions.map((q) =>
            q.question_num === questionNumber ? { ...q, subquestions: updatedSubQuestions } : q
          );

          state[type] = {
            ...questionnaire,
            questions: updatedQuestions,
          };
        }
      }
    },
    updateSubquestionOfSubquestions(state, action) {
      const { value, questionNumber, type, inputType, subquestionsIndex, subSubquestionsIndex } = action.payload;
      const questionnaire = state[type];
      const mainQuestion = questionnaire.questions.find((q: any) => q.question_num === questionNumber);

      if (mainQuestion) {
        const subQuestions = mainQuestion.subquestions;

        if (subQuestions) {
          const subQuestion = subQuestions[subquestionsIndex];

          if (subQuestion) {
            const subSubQuestions = subQuestion.subquestion;

            if (subSubQuestions) {
              let updatedSubSubQuestion: any;
              if (inputType === 'radio' || inputType === 'horizontal-radio') {
                const updatedChoices = subSubQuestions[subSubquestionsIndex].choices.map((choice: any) => ({
                  ...choice,
                  selected: choice.title === value,
                }));

                updatedSubSubQuestion = {
                  ...subSubQuestions[subSubquestionsIndex],
                  choices: updatedChoices,
                };
              } else if (inputType === 'input') {
                updatedSubSubQuestion = {
                  ...subSubQuestions,
                  value: value,
                };
              }

              const updatedSubQuestions = subQuestions.map((sq: any, index: number) =>
                index === subquestionsIndex ? { ...sq, subquestion: updatedSubSubQuestion } : sq
              );
              console.log(updatedSubQuestions)

              const updatedQuestions = questionnaire.questions.map((q) =>
                q.question_num === questionNumber ? { ...q, subquestions: updatedSubQuestions } : q
              );

              state[type] = {
                ...questionnaire,
                questions: updatedQuestions,
              };
            }
          }
        }
      }
    },
    updateSubquestionOfSubquestion(state, action) {
      const { value, questionNumber, type, inputType } = action.payload;
      const questionnaire = state[type];
      const mainQuestion = questionnaire.questions.find((q: any) => q.question_num === questionNumber);

      if (mainQuestion) {
        const subquestion = mainQuestion.subquestion;

        if (subquestion) {
          const subsubquestion = subquestion.subquestion;
          if (subsubquestion) {
            if (inputType === 'radio' || inputType === 'horizontal-radio') {
              subsubquestion.choices.forEach((choice: any) => {
                choice.selected = choice.title === value;
              });
            } else if (inputType === 'input') {
              subsubquestion.value = value;
              console.log(value);
            }
          }
        }
        console.log('subquestion', subquestion);
      }
    },
    toggleSubChoice(state, action) {
      const { choicesIndex, questionsIndex, mainQuestionNum, type } = action.payload;
      const questionnaire = state[type];
      const mainQuestion = questionnaire.questions.find((q: any) => q.question_num === mainQuestionNum);

      if (mainQuestion) {
        const subQuestion = mainQuestion.questions.find((q: any) => q.question_num === questionsIndex);

        if (subQuestion) {
          const updatedChoices = subQuestion.choices.map((choice: any, index: number) => ({
            ...choice,
            selected: index === choicesIndex,
          }));

          const updatedSubQuestions = mainQuestion.questions.map((q: any) =>
            q.question_num === questionsIndex ? { ...q, choices: updatedChoices } : q
          );

          const updatedQuestions = questionnaire.questions.map((q) =>
            q.question_num === mainQuestionNum ? { ...q, questions: updatedSubQuestions } : q
          );

          state[type] = {
            ...questionnaire,
            questions: updatedQuestions,
          };
        }
      }
    },
    toggleMultiSelect(state, action) {
      const { choicesIndex, questionsIndex, type } = action.payload;
      const questionnaire = state[type];
      const question = questionnaire.questions.find((q) => q.question_num === questionsIndex);

      let updatedQuestions;
      const choices = question.choices.map((choice: any, index: number) => ({
        ...choice,
        selected: index === choicesIndex ? !choice.selected : choice.selected,
      }));
      updatedQuestions = questionnaire.questions.map((q) =>
        q.question_num === questionsIndex ? { ...q, choices } : q
      );

      state[type] = {
        ...questionnaire,
        questions: updatedQuestions,
      };
    },
    toggleMultiChoice(state, action) {
      const { choicesIndex, questionsIndex, subQuestionsIndex, type } = action.payload;
      const questionnaire = state[type];
      const question = questionnaire.questions.find((q) => q.question_num === questionsIndex);
      const subQuestion = question.subQuestions[subQuestionsIndex];
      const choices = subQuestion.choices.map((choice: any, index: number) => ({
        ...choice,
        selected: index === choicesIndex,
      }));
      const updatedSubQuestions = question.subQuestions.map((sq: any, index: number) =>
        index === subQuestionsIndex ? { ...sq, choices } : sq
      );
      const updatedQuestions = questionnaire.questions.map((q) =>
        q.question_num === questionsIndex ? { ...q, subQuestions: updatedSubQuestions } : q
      );

      state[type] = {
        ...questionnaire,
        questions: updatedQuestions,
      };
    },
    setPage(state, action) {
      const { page, type } = action.payload;
      if (state[type]) {
        state[type].currentPage = page;
      }
    },
    setContinueLater(state, action) {
      const { type } = action.payload;
      if (state[type]) {
        state[type].continueLater = true;
      }
    },
    setCurrentPage(state, action) {
      const { currentPage, type } = action.payload;
      if (state[type]) {
        state[type].currentPage = currentPage;
      }
    }
  }
});

export const clientQuestionnairesActions = clientQuestionnairesSlice.actions;